import { initContract } from "@ts-rest/core";
import {
	findAllAttendanceFilter,
	PaginatedGroupedDayAttendace,
} from "../validators/grouped-day-attendance.dto";

const c = initContract();

export const attendanceContract = c.router({
	getAttendances: {
		method: "GET",
		path: "/attendances",
		responses: {
			200: c.type<PaginatedGroupedDayAttendace>(),
		},
		query: findAllAttendanceFilter,
	},
});
